import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function Decks() {
  const [list, setList] = useState<any[]>([]);
  useEffect(() => {
    supabase.from("flashcard_decks").select("*").eq("published", true).order("sort_order").then(({ data }) => setList(data || []));
  }, []);
  return (
    <div className="space-y-6 max-w-5xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold">Flashcard Decks</h1>
        <p className="text-muted-foreground">Study with spaced repetition.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((d) => (
          <Link key={d.id} to={`/decks/${d.slug}`}>
            <Card className="hover:shadow-md transition-shadow h-full">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-base">{d.title}</CardTitle>
                  <Badge>{d.jlpt_level}</Badge>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground line-clamp-3">{d.description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
        {!list.length && <p className="text-muted-foreground">No decks yet.</p>}
      </div>
    </div>
  );
}
